module.exports = __webpack_public_path__ + "img/ic_reserve.0ff12bf9.png";